import * as React from "react";
import { Dialog } from "@mui/material";
import useSize from "@app/hooks/useSize";
import { isChromeExtension, getRootElement } from "@app/util/Utils";
/**
 * A wrapper around MUI's `Dialog` component whose modal
 * is rendered within the root element (rather than at the bottom of
 * the document) when we're using the Gmail version of the app.
 *
 * On phone-width viewports (`isDown("sm")`) it defaults to `fullScreen`, so the
 * ~62 modals built on this wrapper use the whole screen instead of a cramped
 * centered box with wasted side margins. Callers can still opt out by passing
 * `fullScreen` explicitly (e.g. a small confirm that should stay centered).
 * See docs/frontend-responsive-conventions.md.
 *
 * @param props
 * @returns
 */
const CoreDialog = (props) => {
    var _a;
    const size = useSize();
    const fullScreen = (_a = props.fullScreen) !== null && _a !== void 0 ? _a : size.isDown("sm");
    return (React.createElement(Dialog, Object.assign({ container: isChromeExtension ? getRootElement() : undefined }, props, { fullScreen: fullScreen }), props.children));
};
export default CoreDialog;
